import { render, staticRenderFns } from "./ProjectInspect.vue?vue&type=template&id=6fc0d61c&scoped=true"
import script from "./ProjectInspect.vue?vue&type=script&lang=js"
export * from "./ProjectInspect.vue?vue&type=script&lang=js"
import style0 from "./ProjectInspect.vue?vue&type=style&index=0&id=6fc0d61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc0d61c",
  null
  
)

export default component.exports